import {
	AfterViewInit,
	Component,
	ComponentRef,
	Input,
	OnChanges,
	OnDestroy,
	Type,
	ViewChild,
	ViewContainerRef,
} from '@angular/core';

@Component({
	selector: 'app-dynamic-template',
	templateUrl: 'dynamic-template.component.html',
})
export class DynamicTemplateComponent implements AfterViewInit, OnDestroy, OnChanges {
	@ViewChild('dynamicComponentContainer', { read: ViewContainerRef })
	dynamicComponentContainer!: ViewContainerRef;
	private componentRef?: ComponentRef<any>;

	@Input() component: Type<any>;
	@Input() componentInputs: any;

	constructor() {}
	ngAfterViewInit() {
		if (!this.dynamicComponentContainer) {
			throw new Error('dynamicComponentContainer is not defined on DynamicTemplateComponent');
		}

		this.loadDynamicComponent();
	}

	ngOnChanges() {
		Object.keys(this.componentInputs).forEach((key) => {
			this.componentRef?.setInput(key, this.componentInputs[key]);
		});
	}

	private destroyDynamicComponent(): void {
		if (this.componentRef) {
			this.componentRef.destroy();
			this.componentRef = undefined;
		}
		this.dynamicComponentContainer?.clear();
	}

	ngOnDestroy(): void {
		this.destroyDynamicComponent();
	}

	private loadDynamicComponent(): void {
		if (this.dynamicComponentContainer) {
			this.destroyDynamicComponent();

			this.componentRef = this.dynamicComponentContainer.createComponent(this.component);
			const componentRef = this.componentRef;

			if (this.componentInputs) {
				Object.keys(this.componentInputs).forEach((key) => {
					componentRef.instance[key] = this.componentInputs[key];
				});
			}
		}
	}
}
